"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preload = void 0;

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var preload = function (doc, config) {
  var cdn = config.cdn || '';
  var scripts = config.scripts || {};
  var scriptsPath = config.scriptsPath || '/assets';

  function asset(href, resourceType) {
    config.preloaded = config.preloaded || {};

    if (!config.preloaded[href]) {
      var preloadLink = doc.createElement('link');
      preloadLink.rel = 'preload';
      preloadLink.as = resourceType;
      preloadLink.href = href;
      doc.head.appendChild(preloadLink);
      config.preloaded[href] = true;
    }
  }

  function script(name) {
    if (scripts[name]) {
      var scriptInfo = scripts[name];
      scriptInfo.hash && scriptInfo.hash.forEach(function (hash) {
        return hash && asset("" + cdn + scriptsPath + "/" + name + "." + hash + ".js", 'script');
      });
      scriptInfo.cssHash && scriptInfo.cssHash.forEach(function (hash) {
        return hash && asset("" + cdn + scriptsPath + "/" + name + "." + hash + ".css", 'style');
      });
    }
  }

  function onNeed(when) {
    for (var name in scripts) {
      var scriptInfo = scripts[name];

      if (scriptInfo.when === when) {
        script(name);
      }
    }
  }

  return {
    asset: asset,
    onNeed: onNeed,
    script: script
  };
};

exports.preload = preload;